<template>
  <tooltip
    custom-class="new-notification-tooltip"
    triggers="manual"
    target="inbox-nav"
    placement="right"
    ref="tooltip"
    boundary="window"
  >
    <div class="p-3 text-left tooltip-container">
      <h2 class="d-flex align-items-center text-nowrap text-large">
        <i class="bell-icon flex-shrink-0 mr-2"></i>
        New Messages
      </h2>
      <b-form-checkbox class="text-medium-1 text-prime mt-3" v-model="dontRemind" name="checkbox-1">
        Don't remind me
      </b-form-checkbox>
      <div class="d-flex justify-content-end mt-3">
        <b-button pill variant="primary" class="px-4" size="sm" @click="dismissTooltip"
          >OK</b-button
        >
      </div>
    </div>
  </tooltip>
</template>

<script>
import * as R from 'ramda'
import Tooltip from '@/components/Tooltip'
import { STORAGE_KEYS } from '@/constants/storage'
import { BButton, BFormCheckbox } from 'bootstrap-vue'

/**
 * Whenever new in-app notification is received, this shows a tooltip beside Inbox link in sidebar.
 */
export default {
  name: 'NewNotificationTooltip',
  props: ['orgId'],
  components: {
    Tooltip,
    BFormCheckbox,
    BButton
  },
  data() {
    return {
      dontRemind: false,
      tooltipDismissed:
        localStorage.getItem(STORAGE_KEYS.newNotificationTooltipDismissed) === 'true'
    }
  },
  computed: {
    notificationSummary() {
      return R.pathOr(
        {},
        ['notificationCenter', this.orgId, 'summary'],
        this.$store.state.notification
      )
    },
    notificationCount() {
      return R.prop('count', this.notificationSummary)
    }
  },
  methods: {
    dismissTooltip() {
      this.$refs.tooltip.close()
      if (this.dontRemind) {
        localStorage.setItem(STORAGE_KEYS.newNotificationTooltipDismissed, 'true')
        this.tooltipDismissed = true
      }
    },
    scheduleAutoClose() {
      clearTimeout(this.timeoutId)
      this.timeoutId = setTimeout(() => {
        this.$refs.tooltip.close()
      }, 5000)
    }
  },
  watch: {
    notificationCount(newCount, previousCount) {
      if (!this.tooltipDismissed && newCount > (previousCount ?? 0)) {
        this.dontRemind = false
        this.$refs.tooltip.open()
        this.scheduleAutoClose()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/_styleConfigurations.scss';

.bell-icon {
  @include dimension(14px, 17px);
}
.tooltip-container {
  min-width: 270px;
}
</style>
<style lang="scss">
@import '~@/styles/_styleConfigurations.scss';

.new-notification-tooltip {
  .tooltip-inner {
    background-color: $documentColor;
    color: $primary;
    box-shadow: 0 4px 10px rgba(51, 51, 51, 0.1), 0 10px 30px rgba(51, 51, 51, 0.3);
  }
  .arrow:before {
    border-right-color: $documentColor;
  }
}
</style>
